import React from 'react';

const ClockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 25 25">
    <path fill="#293840" d="M12.48.5c6.607 0 11.982 5.375 11.982 11.98 0 6.607-5.375 11.982-11.981 11.982S.5 19.087.5 12.48 5.875.5 12.48.5zm0 1.498C6.7 1.998 1.999 6.7 1.999 12.48c0 5.78 4.702 10.483 10.483 10.483 5.78 0 10.483-4.702 10.483-10.483 0-5.78-4.702-10.483-10.483-10.483zm.75 2.995v7.178l4.273 4.273-1.059 1.06-4.712-4.713V4.993h1.498z"/>
  </svg>
);

export default ClockIcon;
